"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildConfigFromPartialConfigV8 = void 0;
const defaultConfig_1 = require("../../defaultConfig");
/**
 * Takes an incomplete incoming config (either from the API or as prop),
 * fills in the defaults from the defaultV8Config and returns the result,
 * which the machine will take and complete by hydrating the template
 * @param partialConfig any (object)
 * @returns V8ServerConfig a completed starting config object
 */
const buildConfigFromPartialConfigV8 = (
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
partialConfig) => {
    if (!partialConfig)
        return (0, defaultConfig_1.defaultV8Config)();
    try {
        const baseConfig = (0, defaultConfig_1.defaultV8Config)(partialConfig.theme);
        const config = {
            customer_code: partialConfig.customer_code || baseConfig.customer_code,
            css: partialConfig.css || baseConfig.css,
            theme: partialConfig.theme || baseConfig.theme,
            params: partialConfig.params || baseConfig.params,
            display_dictionary: partialConfig.display_dictionary || baseConfig.display_dictionary,
            context_map: partialConfig.context_map || baseConfig.context_map,
            index: partialConfig.index || baseConfig.index
        };
        if (partialConfig.params) {
            config.params = Object.assign(Object.assign({}, baseConfig.params), partialConfig.params);
        }
        if (partialConfig.theme) {
            config.theme = Object.assign(Object.assign({}, baseConfig.theme), partialConfig.theme);
        }
        if (partialConfig.display_dictionary) {
            config.display_dictionary = Object.assign(Object.assign({}, baseConfig.display_dictionary), partialConfig.display_dictionary);
        }
        return config;
    }
    catch (e) {
        return (0, defaultConfig_1.defaultV8Config)();
    }
};
exports.buildConfigFromPartialConfigV8 = buildConfigFromPartialConfigV8;
//# sourceMappingURL=buildConfigFromPartialConfigV8.js.map